<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';

    import {mapStore} from '@js/stores/mapStore';
    import {userStore} from '@js/stores/userStore';

    import {showProductModal} from '@js/actions/basketActions';

    import ComboSearch from '@js/components/search/ComboSearch.svelte';

    import PWAManager from '@js/modules/pwaManager';
    import AnalyticsService from '@js/modules/analyticsService';
    import Notification from '@js/components/layouts/notification';

    const {
        rideType,
        mapId
    } = $props();

    mapStore.currentRideType = rideType;

    const _handleLocateMe = () => {
        Notification.info(I18n.t('js.maps.geolocation.in_progress'));

        AnalyticsService.trackPlannerGeolocation('Planner page');

        if (mapStore.map) {
            AnalyticsService.trackGeolocationClick('Planner page');

            mapStore.map.onGeolocation(
                (userLocation) => {
                    setTimeout(() => {
                        Utils.scrollTo(mapId);

                        // Clear current path on map on new search and ask for deletion
                        mapStore.map?.clearMap();

                        mapStore.mapLocation = {
                            type: 'location',
                            bbox: undefined,
                            center: [userLocation.longitude, userLocation.latitude],
                            placeType: 'geolocation',
                            value: 'geolocation'
                        };

                        if (mapStore.map?.hasModule('HELPER') && mapStore.map.displayMapHelper) {
                            mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.position_as_start'));
                        }
                    }, 350);

                    setTimeout(() => Notification.hide(), 600);
                },
                () => {
                    setTimeout(() => Utils.scrollTo(mapId), 350);
                });
        }
    };

    const _handleSelectOnMap = () => {
        AnalyticsService.trackPlannerShowMap('Planner page');

        if (mapStore.map) {
            setTimeout(() => {
                Utils.scrollTo(mapId);

                if (mapStore.map?.hasModule('HELPER') && mapStore.map.displayMapHelper) {
                    mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.click_on_map'));
                }
            }, 350);
        }
    };

    const handleIsochroneChange = (type, value) => {
        if (mapStore.map?.hasModule('HELPER') && mapStore.map.displayMapHelper) {
            mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.isochrone_helper'));
        }

        mapStore.isochroneType = type;
        mapStore.isochroneValue = value;
    };

    const handleUnavailableIsochrone = (type) => {
        showProductModal(type === 'duration' ? 'map_isochrone_duration' : 'map_isochrone_distance');
    };

    const handleRideTypeChange = (type) => {
        mapStore.currentRideType = type;
    };

    const handleSubmit = (comboSearch, {track = true} = {}) => {
        if (comboSearch.location?.name) {
            if (track) {
                AnalyticsService.trackPlannerPlaceSelected();
                AnalyticsService.trackSearch('Planner page', undefined, `${comboSearch.location.value} (${comboSearch.location.placeType})`, 1);
            }

            // Clear current path on map on new search and ask for deletion
            mapStore.map?.clearMap();

            mapStore.mapLocation = comboSearch.location;

            setTimeout(() => Utils.scrollTo(mapId), 100);
        }

        if (comboSearch.useMyPosition) {
            _handleLocateMe();
        } else if (comboSearch.selectOnMap) {
            _handleSelectOnMap();
        } else if (mapStore.map?.hasModule('HELPER') && mapStore.map.displayMapHelper) {
            mapStore.map.displayMapHelper(I18n.t('js.maps.helpers.draw_path'));
        }
    };
</script>

<div class="mb-6">
    <ComboSearch id="planner-search-input"
                 formId="planner-search"
                 placeholder={I18n.t('js.views.planner.search')}
                 searchFeatures={['location']}
                 defaultRideType={$mapStore.currentRideType}
                 autoFocus={PWAManager.getPWADisplayMode() === PWAManager.MODE.BROWSER}
                 useRecentSearch={true}
                 availableDistanceIsochrone={$userStore.featureFlags.map_isochrone_distance}
                 availableDurationIsochrone={$userStore.featureFlags.map_isochrone_duration}
                 onRideTypeChange={handleRideTypeChange}
                 onIsochroneChange={handleIsochroneChange}
                 onUnavailableIsochrone={handleUnavailableIsochrone}
                 onSubmit={handleSubmit}/>
</div>
